import { useQuery } from '@tanstack/react-query';

import { GQLFaqItemsResponse, FaqList, GQLStoriesParams } from './types';
import GetFaqItems from './GetFaqItems.graphql';

import { storyblokGraphQLClient } from '@/utils/storyblok';
import getErrorMessage from '@/utils/errors';
import { FAQ_LIST_PAGE_SIZE } from '@/utils/constants';

// GraphQL request to return to useQuery
export const fetchFaqs = async (
    preview: boolean,
    params?: GQLStoriesParams
): Promise<FaqList> => {
    try {
        const { FaqItems }: GQLFaqItemsResponse = await storyblokGraphQLClient(
            preview
        ).request(GetFaqItems, {
            per_page: FAQ_LIST_PAGE_SIZE,
            ...params,
        });

        return FaqItems;
    } catch (error) {
        //TODO: handle logging errors better, reusable fn wrapper
        const errorMessage = getErrorMessage(error);
        console.error({ message: errorMessage });
        throw new Error(errorMessage);
    }
};

// Get all FAQs with search parameters
export const useFaqItems = (
    faqsRequestParams: GQLStoriesParams,
    preview: boolean
) =>
    useQuery(
        ['faqs', faqsRequestParams],
        () => fetchFaqs(preview, faqsRequestParams),
        {
            staleTime: 1 * 60 * 1000, // Keep data for 1 minute before new fetch
            enabled: !!faqsRequestParams, // Only query if params are provided
        }
    );
